export default __webpack_public_path__ + "static/media/ycombinator.dce84a1f.svg";